import React from 'react';
import { createDivIn } from '../ui_utils/DomUtils.ts';
import { mountUIReactComponent } from './mountUIReactComponent.tsx';
import { getDialogRoot } from '@colonist/ui';
let nextInstanceId = 0;
export function mountDialogUIReactComponent(Component) {
    const containerId = `dialog-container-${nextInstanceId}`;
    nextInstanceId += 1;
    let view;
    return (...args)=>{
        var _args_;
        const props = (_args_ = args[0]) !== null && _args_ !== void 0 ? _args_ : {};
        if (view == undefined) {
            createDivIn(getDialogRoot(), '', containerId);
            view = mountUIReactComponent(containerId, Component);
        }
        const currentView = view;
        const close = ()=>currentView.render({
                ...props,
                open: false,
                onClose: close
            });
        currentView.render({
            ...props,
            open: true,
            onClose: close
        });
    };
}
